import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DynamicFormComponent } from '../../common/dynamic-form/dynamic-form.component';

@Component({
  selector: 'app-save-script-modal',
  standalone: true,
  imports: [CommonModule, DynamicFormComponent],
  templateUrl: './save-script-modal.component.html',
  styleUrl: './save-script-modal.component.scss'
})
export class SaveScriptModalComponent implements OnInit {
   @Input()
    configs: any = {};

  fields: any[] = [];
  isActive:boolean = false;
  activeModal = inject(NgbActiveModal);
  dynamicForm: any = new FormGroup({});
  data: any = {};

  ngOnInit(){
    this.fields = [
      // {
      //   name: "Version Name",
      //   key: 'version',
      //   type: "text-input",
      //   placeholder: "Enter version",
      //   validations: {
      //     required: true
      //   }
      // },
      {
        name: "Label",
        key: 'labels',
        type: "text-input",
        autocompleteOptions: this.configs?.labels,
        placeholder: "Type to pick or create label",
        validations: {
          required: false
        }
      }
    ];
  }

  save() {
    this.activeModal.close(this.dynamicForm.value);    
  }
}
